"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeliveryDisruptionsClient = void 0;
const core_auth_1 = require("@deliverr/core-auth");
const AbstractTransitTimeClient_1 = require("./AbstractTransitTimeClient");
const defaultConfig = {
    authEngine: core_auth_1.AuthEngine.BASIC,
    prefix: "/delivery-disruptions",
    baseURL: process.env.TRANSIT_TIME_SERVICE_URL,
    basicAuthUser: process.env.TRANSIT_TIME_BASIC_AUTH_USER,
    basicAuthPassword: process.env.TRANSIT_TIME_BASIC_AUTH_PASSWORD,
};
class DeliveryDisruptionsClient extends AbstractTransitTimeClient_1.AbstractTransitTimeClient {
    constructor(config = {}) {
        const clientConfig = Object.assign(Object.assign({}, defaultConfig), config);
        super(clientConfig);
    }
    async getDeliveryDisruption(deliveryDisruptionId) {
        return this.get(`${this.prefix}/v1/delivery-disruption/${deliveryDisruptionId}`);
    }
    async getDeliveryDisruptions() {
        return this.get(`${this.prefix}/v1/delivery-disruption`);
    }
    async getDeliveryDisruptionIdsByCorridor(shipMethod, fromZip, toZip, shippedAt, deliverBy) {
        return this.get(`${this.prefix}/v1/delivery-disruption-ids`, {
            shipMethod,
            fromZip,
            toZip,
            shippedAt,
            deliverBy,
        });
    }
}
exports.DeliveryDisruptionsClient = DeliveryDisruptionsClient;
//# sourceMappingURL=DeliveryDisruptionsClient.js.map